var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{directives:[{name:"lazyload",rawName:"v-lazyload"}],staticClass:"rappers",attrs:{"id":"rappers"}},[_c('div',{staticClass:"container"},[_c('RappersTitle'),(_vm.items.length)?[_c('RappersSlider')]:[_c('RappersPreloader')]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }